<template>
  <layout>
    <h4>
      Form Builder
      <router-link
        :to="{ name: 'form-builder.create' }"
        class="btn btn-sm btn-primary">Create
      </router-link>
    </h4>
    <form-builder-base-table
      :resource="resource">

      <template
        slot="title"
        slot-scope="{ item }">
        <a
          :href="item.link"
          target="_blank">
          {{ item.title }}
        </a>
      </template>

      <template
        slot="categories"
        slot-scope="{ item }">
        {{
          ((categories) => {
            let a = [];

            if (typeof categories === "undefined") return [];

            for (let i = 0; i < categories.length; i++) {
              a.push(categories[i].title)
            }

            return a;
          })(item.categories).join(' | ')
        }}
      </template>

    </form-builder-base-table>
  </layout>
</template>

<script>
import Layout from '../layouts/Default.vue';
import FormBuilderBaseTable from '../components/FormBuilderBaseTable.vue';
import Proxy from './Proxy';

const resourceBase = 'form-builder';

export default {
  name: 'FormBuilderIndex',

  components: {
    Layout,
    FormBuilderBaseTable,
  },

  data() {
    return {
      resource: {
        base: resourceBase,
        proxy() {
          return new Proxy();
        },
        sortBy: 'created_at',
        sortDesc: true,
        perPage: 9,
        category: 0,
        fields: [
          {
            key: 'id',
            label: 'ID',
            sortable: true,
          },
          {
            key: 'title',
            label: 'Title',
            sortable: true,
          },
          {
            key: 'categories',
            label: 'Categories',
            sortable: false
          },
          {
            key: 'created_at',
            label: 'Created',
            sortable: true,
          },
        ],
      },
    };
  },

};
</script>
